export function extractAgents(payload) {
    return payload?.filteredView?.item ?? [];
}
export function agentIdOf(agent) {
    return agent.UUID || agent.id || '';
}
export function agentStatusId(agent) {
    return agent.status?.id || 'inactive';
}
export function agentPrimaryEmail(agent) {
    return agent.emails?.[0] || '';
}
